<!--
 * @Author: 仙道
 * @Date: 2022-06-20 21:03:42
 * @LastEditTime: 2023-08-23 15:35:49
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/index.vue
-->
<template>
  <div class="bench-container">
    <layout-grid :layoutData.async="layoutList" @moved="getMovedData" v-if="layoutList.length > 0">
      <template slot="item" slot-scope="data">
        <a-card :bordered="false">
          <div slot="title">{{ data.item.title }}</div>

          <div class="bench-extra" slot="extra">
            <div class="bench-action" v-if="data.item.component === 'QuickMenu'">
              <!-- <a-button size="small" type="plus">添加</a-button> -->

              <div class="bench-extra-icon w-20px">
                <!-- 添加快捷入口 -->
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>添加快捷入口</span>
                  </template>
                  <a-icon @click="addMenu" type="plus" />
                </a-tooltip>
              </div>
            </div>

            <div class="bench-extra-box">
              <div class="bench-extra-icon" v-if="data.item.router">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>详情</span>
                  </template>
                  <a-icon @click="routerPush(data.item.router)" type="container" />
                </a-tooltip>
              </div>
              <div class="bench-extra-icon">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>刷新面板</span>
                  </template>
                  <a-icon @click="refresh(data.item.component)" type="redo" />
                </a-tooltip>
              </div>
              <div class="bench-extra-icon">
                <a-dropdown placement="bottomLeft">
                  <a class="ant-dropdown-link" href="javascript:;">
                    <a-icon type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="deleteFn(data.item)" href="javascript:;">删除</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
            </div>
          </div>
          <component :is="data.item.component" :ref="data.item.component" :y="data.item.y"></component>
        </a-card>
      </template>
    </layout-grid>
    <div class="h-full w-full min-h-400px no-layout flex" v-else>
      <h3>请到顶部导航-个人中心-工作台组件中配置页面</h3>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import LayoutGrid from './testGridLayout/index.vue'
import PageOne from './components/PanelOne.vue'
import PageTwo from './components/PanelTwo.vue'

import PageThree from './components/PanelThree.vue'
import PageFour from './components/PanelFour.vue'
import PendingOrder from './components/pendingOrder.vue'
// import Calendar from './components/calendar.vue'
import Calendar from '@/views/eMaintenance/MaintaincePlanCalendar.vue'
import QuickMenu from './components/quickMenu.vue'
import Overhaul from './components/overhaul.vue'

import DefRegister from './components/defRegister.vue'
import WaterRecord from './components/WaterRecord.vue'
import ViolationRecord from './components/ViolationRecord.vue'

import { httpAction, deleteAction } from '@/api/manage'

export default {
  name: 'WobenchIndex',
  components: {
    LayoutGrid,
    QuickMenu,
    PageOne,
    PageTwo,
    PageThree,
    PageFour,
    PendingOrder,
    Calendar,
    Overhaul,
    DefRegister,
    WaterRecord,
    ViolationRecord
  },
  // 定义属性
  data() {
    return {
      loading: true
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters(['layoutList', 'benchData', 'routeList'])
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    ...mapActions(['InitWorkbench']),

    getMovedData({ i, newX, newY }) {
      const moveItem = this.layoutList.find(item => item.i === i)
      const componentItem = this.benchData.get(moveItem.component)

      console.log('拖拽排序之后：', moveItem)
      httpAction(
        '/custom/sysUserComponent/edit',
        {
          ...componentItem,
          componentData: JSON.stringify(moveItem)
        },
        'put'
      ).then(res => {
        // this.InitWorkbench()
      })
    },
    deleteFn(item) {
      const benchDataItem = this.benchData.get(item.component)

      deleteAction('/custom/sysUserComponent/delete', { id: benchDataItem.id }).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.InitWorkbench()
        }
      })
    },
    refresh(ref) {
      this.$refs[ref].queryData()
    },
    addMenu() {
      this.$refs['QuickMenu'].openModal()
    },
    routerPush(name) {
      let route = this.routeList.find(item => item.name === name)
      if (!route) {
        this.$message.error('当前角色无访问权限')
        return
      }
      if (route.path) {
        this.$router.push({ path: route.path })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bench-container {
  // background: #fff;
  height: 100%;
  padding-bottom: 20px;
  .no-layout {
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
  }
}
::v-deep {
  .ant-card-body {
    overflow-y: scroll;
    // &::-webkit-scrollbar {
    //   /*滚动条整体样式*/
    //   width: 5px;
    //   height: 1px;
    // }

    // &::-webkit-scrollbar-thumb {
    //   /*滚动条里面的滑块*/
    //   border-radius: 5px;
    //   background: rgba(100, 177, 240, 0.5);
    // }

    // &::-webkit-scrollbar-track {
    //   /*滚动条里面轨道背景*/
    //   border-radius: 5px;
    //   background: rgba(0, 0, 0, 0.1);
    // }
  }
  .bench-extra {
    // display: flex;
    // flex: 1;
    .bench-action {
      flex: 1;
    }
    .bench-extra-box {
      width: 100px;
      display: flex;
      justify-content: end;
    }
  }
  .ant-card-extra {
    // font-size: 20px;
    // width: 100px;
    padding: 5px;
    flex: 1;
    // justify-content: space-between;
    .bench-extra {
      width: 100%;
      display: flex;
      // justify-content: space-between;
      justify-content: right;
      &-icon {
        padding: 4x;
        cursor: pointer;
        margin-left: 15px;
        &:hover {
          background: #ccc;
        }
      }
    }
    .anticon {
      font-size: 20px;
      font-weight: 700;
    }
  }
}
</style>
